import { render, staticRenderFns } from "./r-settings-page.vue?vue&type=template&id=3216bce6"
import script from "./r-settings-page.vue?vue&type=script&lang=js"
export * from "./r-settings-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3216bce6')) {
      api.createRecord('3216bce6', component.options)
    } else {
      api.reload('3216bce6', component.options)
    }
    module.hot.accept("./r-settings-page.vue?vue&type=template&id=3216bce6", function () {
      api.rerender('3216bce6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/settings/r-settings-page.vue"
export default component.exports